import { render, staticRenderFns } from "./BaseLocationLayoutsMenu.vue?vue&type=template&id=636e2560&scoped=true"
import script from "./BaseLocationLayoutsMenu.vue?vue&type=script&lang=js"
export * from "./BaseLocationLayoutsMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636e2560",
  null
  
)

export default component.exports